import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { deepOrange } from '@material-ui/core/colors';
import CloseSharpIcon from '@material-ui/icons/CloseSharp';
import RefreshSharpIcon from '@material-ui/icons/RefreshSharp';
import CallReceivedIcon from '@material-ui/icons/CallReceived';
import { Box } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import PropTypes from 'prop-types';
import Rating from '@material-ui/lab/Rating';
import SentimentVeryDissatisfiedIcon from '@material-ui/icons/SentimentVeryDissatisfied';
import SentimentDissatisfiedIcon from '@material-ui/icons/SentimentDissatisfied';
import SentimentSatisfiedIcon from '@material-ui/icons/SentimentSatisfied';
import SentimentSatisfiedAltIcon from '@material-ui/icons/SentimentSatisfiedAltOutlined';
import SentimentVerySatisfiedIcon from '@material-ui/icons/SentimentVerySatisfied';

//components
import LogoAvatar from './LogoAvatar'
import { sendMessage } from '../services/WatsonService';


//import Conversation from '../models/Conversation';
//import Toolbar from '@material-ui/core/Toolbar';
//import IconButton from '@material-ui/core/IconButton';
//import Replay  from '@material-ui/icons/Replay';
//import Close  from '@material-ui/icons/Close';
//import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
//import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
//import { NeuButton } from "neumorphism-react";
//import { NeuDiv } from "neumorphism-react";
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
//import { faRedo, faTimes } from '@fortawesome/free-solid-svg-icons';
//import GitInfo from 'react-git-info/macro';





const useStyles = makeStyles((theme) =>
  createStyles({
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {    
      flexGrow: 1,
      color: theme.palette.getContrastText(deepOrange[500]),
      fontWeight: 600,
      lineHeight: "52px",
      //fontSize: "16px",
      verticalAlign:"sub",
      

    },
    caption: {
      color:theme.palette.getContrastText(deepOrange[500]),
    },
    iconButton: {
      //color: theme.palette.getContrastText(deepOrange[500]),
    },
    appBar: {
      flexGrow: 1,
      margin: 0,
      width: "100%",
      padding:"5px 15px"
    },
    clsIcon:{
      color:"#FFF",
      lineHeight: "5!important",
      marginTop: '15px'
    },
    btn: {
      margin: theme.spacing(1),
      background: "#f26522",
      color: "#fff",
    },
    
    modalHeader:{
      textAlign: 'center', 
      color:'#fff',
      padding: "11px",
      background: "#f26522",
      borderTopLeftRadius: "7px",
      borderTopRightRadius: "7px",
    },

//PAPER is for MODAL
    paper: {
      position: 'fixed',
      transform: "translate(-50%, -50%)",
      width: "97%", //Old value was 400px
      backgroundColor: theme.palette.background.paper,
      borderBottom: "10px solid #f26522",
      boxShadow: theme.shadows[5],
      borderRadius: "10px",
      color: '#162b75',
      opacity: "0.95",
      backgroundImage: "radial-gradient(#f265227d 0.35px, #fff 0.35px)",
      backgroundSize: "7px 7px",
      //border: "2px solid #334"
    //border: '2px solid #f26522',
    //padding: theme.spacing(2, 4, 3),
    //background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
    //border: '2px solid #000',
      
    //boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
    //color: 'white',
    //padding: theme.spacing(2, 4, 3),
    },
   

  }),
);

//Rating ICON initialization 
const customIcons = {
  1: {
    icon: <SentimentVeryDissatisfiedIcon fontSize="large"/>,
    label: 'Very Dissatisfied',
  },
  2: {
    icon: <SentimentDissatisfiedIcon fontSize="large"/>,
    label: 'Dissatisfied',
  },
  3: {
    icon: <SentimentSatisfiedIcon fontSize="large"/>,
    label: 'Neutral',
  },
  4: {
    icon: <SentimentSatisfiedAltIcon fontSize="large" /*color="secondary"*/  />,
    label: 'Satisfied',
  },
  5: {
    icon: <SentimentVerySatisfiedIcon fontSize="large"/>,
    label: 'Very Satisfied',
  },
};

function IconContainer(props) {
  const { value, ...other } = props;
  return <span {...other}>{customIcons[value].icon}</span>;
}


IconContainer.propTypes = {
  value: PropTypes.number.isRequired,
};

//const gitInfo = GitInfo();

const Appbar = (props) => {
  const classes = useStyles();

  //const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);

  const [rating, setRating] = React.useState(false); //Rating

  const [errMsg, setErrMsg] = React.useState();
 
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onSendClicked = () => {  
    let conv = props.conv;
    console.log("TESTING :"+ rating); 
    if(rating !== false){
      setRating("Thanks for submitting your feedback!");
      sendMessage(rating, conv.context)
      .then(conversation => {
        onCloseClick();
      })
      .catch(error => console.log(error));
    }else{     
      setErrMsg("Please give rating above then click 'Submit' or click 'Close' to exit.");
      setRating(false);
    }
  }


  const onCloseClick = ()=>{
    window.parent.document.getElementById("mainDiv").classList.remove('bob-open-chat-iframe');
    let botSrc = window.parent.document.getElementById("chatIframe").src;
    window.parent.document.getElementById("chatIframe").src = botSrc;

  }

  const onMinimiseClick = () => {
    window.parent.document.getElementById("mainDiv").classList.remove('bob-open-chat-iframe');
  }

  const onRefreshClick = () =>{
    let botSrc = window.parent.document.getElementById("chatIframe").src;
    window.parent.document.getElementById("chatIframe").src = botSrc;
  }

 


    return (
      <AppBar position="sticky" elevation={0} className={classes.appBar} >
        {/* <NeuDiv style={{padding:"5px 10px 0"}} width="100%" height="100%" radius={1} distance={props.elevate?0:0} color={deepOrange[500]}> */}
          <Box width="100%">
            <Grid container spacing={1} alignItems="stretch">
              <Grid item xs={2} sm={2} md={2} lg={1} xl={2}> 
                {/* <NeuDiv height="100%" radius={5}  distance={0} color={deepOrange[500]}> */}
                  <LogoAvatar dark={true} />
                  <svg style={{position:"absolute", top:"40px", left:"50px"}}   width="15" height="15" viewBox="0 0 24 24" fill="green" xmlns="http://www.w3.org/2000/svg"><path /*fill-rule="evenodd"*/ clipRule="evenodd" d="M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z" fill="green" /></svg>
              </Grid>
              <Grid item xs={3} sm={3} md={3} lg={4} xl={3} style={{margin:'auto', marginLeft:'4px'}}>   
                  <Typography variant="h5" className={classes.title} align="left">
                    <Box lineHeight={2} >
                      Ask ADI  
                      </Box>
                    {/* <Box fontSize={10} className={classes.caption} lineHeight={0} m={1}>
                        v2.1.5-beta
                    </Box> */}
                  </Typography>
                {/* </NeuDiv> */}
              </Grid>
              <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                
              </Grid>

              <Grid item xs={1} sm={1} md={1} lg={1} xl={1} >
                <RefreshSharpIcon className={classes.clsIcon} onClick={onRefreshClick} /*fontSize="large" onClick={props.resetHandler}*/ />  
              </Grid> 
              <Grid item xs={1} sm={1} md={1} lg={1} xl={1} >
                <CallReceivedIcon className={classes.clsIcon} onClick = {onMinimiseClick} /*fontSize="large"*/ />  
              </Grid>
              <Grid item xs={1} sm={1} md={1} lg={1} xl={1} >                      
                <CloseSharpIcon className={classes.clsIcon} /*fontSize="large"*/ onClick={handleOpen}/>

                <Modal
                  disableEscapeKeyDown
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="rating-modal-title"
                  aria-describedby="rating-modal-description"
                >
                  <div style={{top:'30%', left:'50%'}} className={classes.paper}>
                      <h4 className={classes.modalHeader} id="rating-modal-title">It was great seeing you today !!!</h4>
                      <h5 style={{textAlign: 'center', color:'#162b75'}} >On exiting, all chat history will be cleared</h5>
                      <p id="rating-modal-description">
                        <Box component="fieldset" mb={3} borderColor="transparent" style={{textAlign: 'center'}}>
                          <Typography component="legend">Would you kindly consider leaving us a rating.</Typography>
                          <Rating style={{padding: '10px 10px 5px 10px'}}
                            name="customized-icons"
                            defaultValue={0}
                            getLabelText={(value) => customIcons[value].label}
                            IconContainerComponent={IconContainer}
                            onChange={(event, value) => {
                              setErrMsg("");
                              setRating(customIcons[value].label);
                            }}
                          />
                          <h5 component="legend" align="center" id="ratingSelected" style={{color:'green', padding: '0 10px'}}> {rating} </h5>
                          <h5 component="legend" align="center" id="errorMSg" style={{color:'red'}}> {errMsg} </h5>
                        
                        </Box>
                        
                          
                        <Box component="fieldset" mb={3} borderColor="transparent" style={{textAlign: 'center'}}>
                          <Button variant="outlined" style={{ backgroundColor: '#f26522' }} size="small" onClick = {onSendClicked} className={classes.btn}>Submit</Button>
                          <Button variant="outlined" style={{ backgroundColor: '#f26522' }} size="small" onClick = {onCloseClick} /*onClick={props.closeHandler}*/ className={classes.btn}>Close</Button>                                  
                        </Box>
                        
                      </p>                              
                  </div>
                </Modal>
                {/* {<NeuButton
                  width="45px"
                  height="40px"
                  radius={45}
                  distant={1}
                  onClick={props.closeHandler}
                  color={deepOrange[500]}
                >
                  <FontAwesomeIcon icon={faTimes} color={grey[200]} />
                </NeuButton>} */}
              </Grid>
            </Grid>
        </Box>
              
        {/* </NeuDiv> */}
        
        {/* <svg viewBox="545 0 800 165"><path fill="#fff" fill-opacity="1" d="M0,32L48,80C96,128,192,224,288,224C384,224,480,128,576,90.7C672,53,768,75,864,96C960,117,1056,139,1152,149.3C1248,160,1344,160,1392,160L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg> */}
        {/* <svg viewBox="0 0 1440 259">
          <path fill="#fff" fill-opacity="1" d="M0,32L48,80C96,128,192,224,288,224C384,224,480,128,576,90.7C672,53,768,75,864,96C960,117,1056,139,1152,149.3C1248,160,1344,160,1392,160L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
        </svg> */}
      </AppBar>

      
    )
}

export default Appbar;